import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DateService } from '../date/date.service';
import { lastValueFrom } from 'rxjs';
import { SessionService } from '../session/session.service';
import { PaginateResult } from 'src/app/models/paginateresult';
import { ReportItem } from 'src/app/models/reportitem';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl + '/report';
  }

  public all(): Promise<any> {
    const token = SessionService.getToken();

    return lastValueFrom(this.http.get<any>(this.baseUrl + '/?token=' + token)).then(data => data);
  }

  public filter(kind: string, filter: any): Promise<any> {
    const endpointMap: Record<string, string> = {
      place: 'prefix',
      distributionCenter: 'distribution-center',
      state: 'state',
      status: 'order-situation',
      classification: 'classification',
      'comunication': 'action-comunication',
      'action-comunication': 'action-comunication',
      'item-type': 'item-type'
    };

    const endpoint = `${kind !== 'place' ? 'report-filter/filter' : 'report-filter'}/${
      endpointMap[kind]
    }`;

    console.log('current-endpoint', endpoint)

    const params = new HttpParams({ fromObject: filter });

    return lastValueFrom(this.http.get<any>(`${environment.apiUrl}/${endpoint}`, { params })).then(
      data => data
    );
  }

  public combobox(id: number | string | boolean, kind: string): Promise<any> {
    const token: string = SessionService.getToken();
    var request = kind === 'place' ? 'report-filter/prefix' : `report/${id}/combobox/${kind}`;

    return lastValueFrom(this.http.get<any>(`${environment.apiUrl}/${request}`)).then(data => data);
  }

  public reportOrder(filters?: any): Promise<PaginateResult<ReportItem>> {
    const params = new HttpParams({ fromObject: filters });

    return lastValueFrom(this.http.get<any>(`${this.baseUrl}/order`, { params: params })).then(
      data => data
    );
  }

  public reportExportOrder(filters?: any): Promise<any[]> {
    const params = new HttpParams({ fromObject: filters });

    return lastValueFrom(this.http.get<any>(`${this.baseUrl}/order`, { params: params })).then(
      data => data
    );
  }

  public reportProductionItem(filters?: any): Promise<any> {
    const params = new HttpParams({ fromObject: filters });

    return lastValueFrom(
      this.http.get<any>(`${this.baseUrl}/item-production`, { params: params })
    ).then(data => data);
  }

  public get(
    id: number | string | boolean,
    start: Date,
    end: Date,
    filters?: string,
    first: number = 0,
    rows: number = 5,
    sorts?: string
  ): Promise<any> {
    const ss: string = DateService.date(start);
    const se: string = DateService.date(end);

    const token: string = SessionService.getToken();
    let url: string = this.baseUrl + '/' + id + '?start=' + ss + '&end=' + se + '&token=' + token;

    if (filters !== undefined && filters !== null && filters.length > 0)
      //
      url += '&filters=' + filters;

    if (first !== undefined && first !== null && first > 0)
      //
      url += '&first=' + first;

    if (rows !== undefined && rows !== null && rows > 0)
      //
      url += '&rows=' + rows;

    if (sorts !== undefined && sorts !== null && sorts.length > 0)
      //
      url += '&sorts=' + sorts;

    return lastValueFrom(this.http.get<any>(url)).then(data => {
      // console.log(data);

      // TODO: Remove when Reason is working to rating
      if (id === '013' || id === '014')
        //
        // TODO: Is removing Reason column
        data.cols.pop();

      return data;
    });
  }
}
